import React, { useState, useEffect, useRef, SyntheticEvent } from "react";
import {
  getLicenceDetails,
  saveVetHealthInspection,
  getInspectionById,
  getSalutations,
  getTradenetPermitDetailsbyPermitNumber,
  getPorts,
} from "../../api/apimethods";
import { notify } from "../../utils";
import { NotifyType } from "../../utils/app-config";
import { useNavigate, useLocation } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import { countryMobileCodes } from "../../scripts/countryMobileCodes";
import { Holiday } from "../../typings/models/Holiday";
import { IcountryOptions } from "../../typings/models/CountryOption";
import fetchCountryOptions from "../../scripts/countryOptions";
import fetchHolidaysMaster from "../../scripts/holidaysMaster";
import { IVetHealthInspectionRequest } from "../../typings/interfaces/Requests/VetHealthInspectionRequest";
import { ICodeMasterModel } from "../../typings/models/CodeMasterModel";
import {
  differenceInHours,
  addHours,
  setHours,
  setMinutes,
  setSeconds,
  addMinutes,
  isAfter,
  isBefore,
} from "date-fns";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { defaultAppContextData } from "../../services/appData";
import { useConfig } from "../../context/ConfigProvider";
import { useContextService } from "../../services";
import Loader from "../../components/molecules/Loader";
import { ErrorMessage } from "@hookform/error-message";
import { AxiosError } from "axios";

const VetHealthInspectionApplication: React.FC = () => {
  const { getContextValueFromStorage } = useContextService();
  const [contextData] = useState(() =>
    getContextValueFromStorage(defaultAppContextData)
  );
  const user = contextData.user;
  const cfg = useConfig();
  const site_Key: string = cfg.REACT_APP_SITE_KEY ?? "";
  const [apiErrorMessage, setApiErrorMessage] = useState<string | null>(null);
  const inputHolidayRef = useRef(true);
  const inputCountryRef = useRef(true);
  const { message } = notify();
  const inputUserRef = useRef(true);
  const [loading, setLoading] = useState(false);
  const [IsView, setIsView] = useState<boolean>(false);
  const [IsAmend, setIsAmend] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [typeofTransaction, setTypeofTransaction] = useState("");
  const [certificateNumber, setCertificateNumber] = useState("");
  const [typeofPermit, setTypeofPermit] = useState("");
  const [typeofPermitText, setTypeofPermitText] = useState("");
  const [isalutation, setiSalutation] = useState("0");
  const [iapplicantName, setiApplicantName] = useState("");
  const [smobileNo, setsMobileNo] = useState("");
  const [imobilecode, setiMobileCode] = useState("+65");
  const [iemail, setiEmail] = useState("");
  const [authorizedPersonName, setAuthorizedPersonName] = useState("");
  const [authPersonEmail, setAuthPersonEmail] = useState("");
  const [authPersonContactNumber, setAuthPersonContactNumber] = useState("+65");
  const [consignmentType, setConsignmentType] = useState("");
  const [arrivalMethod, setArrivalMethod] = useState("");
  const [shipmentBy, setShipmentBy] = useState("");
  const [flightNumber, setFlightNumber] = useState("");
  const [vehicleNumber, setVehicleNumber] = useState("");
  const [vessel, setVessel] = useState("");
  const [shipInfo, setShipInfo] = useState("");
  const [arrivalDate, setArrivalDate] = useState<Date | null>(null);
  const [minBookingDate, setminBookingDate] = useState<Date | null>(null);
  const [maxDepartureDate, setMaxDepartureDate] = useState<Date | null>(null);
  const [arrivalTime, setArrivalTime] = useState<Date | null>(
    setHours(setMinutes(new Date(), 0), 9)
  );
  const [shipmentDate, setShipmentDate] = useState<Date | null>(null);
  const [shipmentTime, setShipmentTime] = useState<Date | null>(
    setHours(setMinutes(new Date(), 0), 9)
  );
  const [countryofDestination, setCountryofDestination] = useState("");
  const [exportCountryofDestination, setExportCountryofDestination] =
    useState("");
  const [countryOfOrigin, setCountryOfOrigin] = useState("");

  const [checkinofAnimal, setCheckinofAnimal] = useState("-1");
  const [stopoverPortCountry, setStopoverPortCountry] = useState("");
  const [stopoverPortDuration, setStopoverPortDuration] = useState("");
  const [seaPortforInspection, setSeaPortforInspection] = useState("-1");
  const [ainspectionDateTime, setainspectionDateTime] = useState<Date | null>(
    null
  );
  const [ainspectionTime, setaInspectionTime] = useState<Date | null>(
    setHours(setMinutes(new Date(), 0), 9)
  );
  const [inspectionLocation, setInspectionLocation] = useState("");
  const [otherAppointedPlace, setOtherAppointedPlace] = useState("");
  const [aRemarks, setaRemarks] = useState("");
  const [aModeofContact, setaModeofContact] = useState<number>(0);
  const [amobileNo, setaMobileNo] = useState("");
  const [hideOtherAppointedPlace, setHideOtherAppointedPlace] = useState(true);

  const [validEmail, setValidEmail] = useState(true);
  const [validAuthEmail, setValidAuthEmail] = useState(true);
  const [submitted, setSubmitted] = useState(false);
  const [checkboxChecked, setCheckboxChecked] = useState(false);
  const [isalutationSelected, setiSalutationSelected] = useState(false);
  const [modeofContactSelected, setaModeofContactSelected] = useState(false);
  const recaptchaRef = useRef<ReCAPTCHA>(null);

  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() + 1);
  const [validMobileNo, setValidMobileNo] = useState(true);
  const [certificateNumberShowError, setCertificateNumberShowError] =
    useState(false);
  const [certificateNumberNoShowError, setCertificateNumberNoShowError] =
    useState(true);
  const [validaMobileNo, setValidaMobileNo] = useState(true);
  const [isCaptchaValid, setIsCaptchaValid] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmiting, setSubmiting] = useState(false);
  const [isValidDate, setisValidDate] = useState(true);
  const [isTimeValid, setTimeValid] = useState(true);
  const [isInspectionTimeValid, setInspectionTimeValid] = useState(true);
  const [isValidInspectionDate, setisValidInspectionDate] = useState(true);
  const [isArrivalDateValid, setisArrivalDateValid] = useState(true);
  const [isArrivalTimeValid, setisValidArrivalTime] = useState(true);
  const [isShipmentDateValid, setisShipmentDateValid] = useState(true);
  const [isShipmentTimeValid, setisValidShipmentTime] = useState(true);
  const [holidays, setHolidays] = useState<Holiday[]>([]);
  const [countries, setCountries] = useState<IcountryOptions[]>([]);
  const [ports, setPorts] = useState<ICodeMasterModel[]>([]);
  const [inspectionCaseId, setInspectionCaseId] = useState("");
  const [viewMode, setViewMode] = useState(false);
  const [amendMode, setamendMode] = useState(false);
  const [disableInspectionDate, setDisableInspectionDate] = useState(true);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [showFields, setShowFields] = useState(false);
  const [salutationOptions, setSalutationOptions] = useState<
    ICodeMasterModel[]
  >([]);
  const [showFormFields, setShowFormFields] = useState(false);
  const [showOtherFields, setShowOtherFields] = useState(false);
  const [minInspectionDate, setMinInspectionDate] = useState<Date | null>(null);
  const [minInspectionTime, setMinInspectionTime] = useState(
    setHours(setMinutes(setSeconds(new Date(), 0), 0), 9)
  );
  const [maxInspectionDate, setMaxInspectionDate] = useState<Date | null>(null);
  const [maxInspectionTime, setMaxInspectionTime] = useState(
    setHours(setMinutes(setSeconds(new Date(), 0), 0), 20)
  );
  const [portofExit, setPortofExit] = useState("");
  const [departureDate, setDepartureDate] = useState<Date | null>(null);
  const [departureTime, setDepartureTime] = useState<Date | null>(null);
  const [minDepartureTime, setMinDepartureTime] = useState(
    setHours(setMinutes(setSeconds(new Date(), 0), 0), 9)
  );
  const [maxDepartureTime, setMaxDepartureTime] = useState(
    setHours(setMinutes(setSeconds(new Date(), 0), 0), 21)
  );
  const [flightDetails, setFlightDetails] = useState("");
  const [isDepartureDateValid, setisDepartureDateValid] = useState(true);

  let navigate = useNavigate();

  const location = useLocation();
  let inspectionId = location.state?.id;
  let inspectionmode = location.state?.mode;
  const isWeekend = (date: any) => {
    const day = date.getDay();
    return day === 0; // Sunday (0) or Saturday (6)
  };

  const isHoliday = (date: any) => {
    const dateString = date.toString().split("T");
    return holidays.some(
      (holiday) =>
        // holiday.holidayDate.split("T").includes(dateString)
        date.toDateString() === new Date(holiday.holidayDate).toDateString()
    );
  };

  // Calculate min and max time for departure based on arrival time
  const calculateDepartureMinTime = (date: Date) => {
    if (!arrivalTime) return null; // No restriction if arrivalTime is not set

    // Clone the date to avoid mutating the input
    const clonedDate = new Date(date);

    if (arrivalTime.getDay() === date.getDay()) {
      // If on the same day as arrivalTime, add 2 hours
      return addHours(arrivalTime, 2);
    } else {
      // Otherwise, set the time to midnight (00:00)
      return setHours(setMinutes(setSeconds(clonedDate, 0), 0), 0);
    }
  };

  const calculateDepartureMaxTime = (date: Date) => {
    if (!arrivalTime) return null; // No restriction if arrivalTime is not set
    if (arrivalTime.getDay() == date.getDay()) {
      return setHours(setMinutes(setSeconds(arrivalTime, 0), 59), 23);
    } else {
      let hours = addHours(arrivalTime, +24);
      return hours;
    }
  };

  const addOneDay = (date: any) => {
    const newDate = new Date(date);
    newDate.setDate(date.getDate() + 1);
    return newDate;
  };

  const removeOneDay = (date: any) => {
    const newDate = new Date(date);
    newDate.setDate(date.getDate() - 1);
    return newDate;
  };

  const setInspectionTime = (date: any, location?: string) => {
    const day = date.getDay();
    const loc = location != undefined ? location : inspectionLocation;
    date = date ?? new Date();
    setMinInspectionTime(setHours(setMinutes(setSeconds(date, 0), 0), 0));
    setMaxInspectionTime(setHours(setMinutes(setSeconds(date, 0), 59), 23));
    if (loc === "1") {
      if (day === 1 || day === 2) {
        setMinInspectionTime(setHours(setMinutes(setSeconds(date, 0), 0), 9));
        setMaxInspectionTime(setHours(setMinutes(setSeconds(date, 0), 0), 17));
      }
      if (day === 3 || day === 4 || day === 5) {
        setMinInspectionTime(setHours(setMinutes(setSeconds(date, 0), 0), 9));
        setMaxInspectionTime(setHours(setMinutes(setSeconds(date, 0), 0), 20));
      }
      {/*if (day === 6) {
        setMinInspectionTime(setHours(setMinutes(setSeconds(date, 0), 0), 10));
        setMaxInspectionTime(setHours(setMinutes(setSeconds(date, 0), 30), 20));
      }*/}
    }
    if (loc === "2") {
      setMinInspectionTime(setHours(setMinutes(setSeconds(date, 0), 0), 5));
      setMaxInspectionTime(setHours(setMinutes(setSeconds(date, 0), 0), 11));
    }
    if (arrivalDate?.getDate() === date.getDate())
      ChangeMinInspectionDate(arrivalTime, arrivalDate);

    if (shipmentDate?.getDate() === date.getDate())
      ChangeMaxInspectionDate(shipmentTime, shipmentDate);
  };

  const getMinInspectionTime = (date: any, location?: string) => {
    const day = date.getDay();
    const loc = location != undefined ? location : inspectionLocation;
    date = date ?? new Date();
    if (loc === "1") {
      if (day === 1 || day === 2 || day === 3 || day === 4 || day === 5) {
        return setHours(setMinutes(setSeconds(date, 0), 0), 9);
      }
      if (day === 6) {
        return setHours(setMinutes(setSeconds(date, 0), 0), 10);
      }
    } else if (loc === "2") {
      return setHours(setMinutes(setSeconds(date, 0), 0), 5);
    } else {
      return setHours(setMinutes(setSeconds(date, 0), 0), 0);
    }
  };

  const getMaxInspectionTime = (date: any, location?: string) => {
    const day = date.getDay();
    const loc = location != undefined ? location : inspectionLocation;
    date = date ?? new Date();
    if (loc === "1") {
      if (day === 1 || day === 2) {
        return setHours(setMinutes(setSeconds(date, 0), 0), 17);
      }
      if (day === 3 || day === 4 || day === 5) {
        return setHours(setMinutes(setSeconds(date, 0), 0), 20);
      }
    } else if (loc === "2") {
      return setHours(setMinutes(setSeconds(date, 0), 0), 11);
    } else {
      return setHours(setMinutes(setSeconds(date, 0), 59), 23);
    }
  };

  useEffect(() => {
    if (inputUserRef.current) {
      inputUserRef.current = false;

      if (user) {
        if (user.name) setiApplicantName(user.name);
        if (user.contactNo) {
          setiMobileCode(user.contactNo.substring(0, 3));
          setsMobileNo(user.contactNo.substring(3));
        }
        if (user.email) setiEmail(user.email);
      }

      const fetchSalutation = async () => {
        try {
          const response = await getSalutations();

          if (response.data) {
            const salutations = response.data.filter(
              (item) => item.name !== "Others" && item.name !== "Not Available"
            );
            setSalutationOptions(salutations);
          }
        } catch (error) {
          console.error("Error fetching salutations:", error);

          message(
            NotifyType.Error,
            "An error occurred while fetching salutations. Please try again."
          );
        }
      };

      fetchSalutation();
    }
  }, []);

  const consignmentTypeChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    var consignmentType = event.target.value;
    setConsignmentType(consignmentType);
    if (consignmentType === "3") setShowFields(true);
  };

  const fillLicenceDetails = async (
    licenceNumber: string,
    typeofTransaction: string,
    typeofPermit: string
  ) => {
    if (
      (typeofPermit === "1" || typeofPermit === "2") &&
      licenceNumber !== ""
    ) {
      setLoading(true);
      setApiErrorMessage(null);
      var type = "";
      if (typeofTransaction === "3") type = "CITES";
      try {
        const response = await getLicenceDetails(
          licenceNumber,
          typeofTransaction,
          typeofPermit
        );

        if (response.data) {
          setLoading(false);
          setCertificateNumberShowError(false);
          setDisableSubmit(false);
          setiApplicantName(response.data.name);
          if (response.data.salutation)
            setiSalutation(response.data.salutation);
          if (response.data.applicantMobileNo) {
            setiMobileCode(response.data.applicantMobileNo.substring(0, 3));
            setsMobileNo(response.data.applicantMobileNo.substring(3));
          }
          setiEmail(response.data.applicantEmail);
        } else {
          setLoading(false);
          setCertificateNumberShowError(true);
          setDisableSubmit(true);
          setApiErrorMessage("No data found.");
        }
      } catch (error) {
        setLoading(false);
        setCertificateNumberShowError(true);
        setDisableSubmit(true);

        setApiErrorMessage("An error occurred while fetching licence details.");
        console.error(error);
      }
    }
  };

  const handleTypeofTransactionChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    var typeofTransaction = event.target.value;
    typeofTransactionChange(typeofTransaction);
  };

  // Function to calculate the minDate
  const calculateMinDate = () => {
    let date = new Date();
    let daysToAdd = 1;

    while (daysToAdd > 0) {
      date.setDate(date.getDate() + 1); // Move to the next day
      if (!isWeekend(date) && !isHoliday(date)) {
        // Skip Sundays and holidays
        daysToAdd--;
      }
    }

    return date;
  };

  // Function to calculate the minDate
  const calculateMaxDepartureDate = (date: Date) => {
    if (!date) return null;

    // Clone the date to avoid mutating the input
    const clonedDate = new Date(date);
    let daysToAdd = 1;

    while (daysToAdd > 0) {
      clonedDate.setDate(clonedDate.getDate() + 1); // Move to the next day
      if (!isWeekend(clonedDate) && !isHoliday(clonedDate)) {
        // Decrement daysToAdd only for non-weekend and non-holiday days
        daysToAdd--;
      }
    }

    return clonedDate;
  };

  const typeofTransactionChange = (typeofTransaction: string) => {
    setTypeofTransaction(typeofTransaction);
    setShowFormFields(true);
    if (typeofTransaction === "3") {
      //setTypeofPermit("2");
      setShowOtherFields(true);
      setDisableInspectionDate(false);
      setMinInspectionDate(new Date());
    } else {
      setShowOtherFields(false);
      setMinInspectionDate(null);
    }

    setminBookingDate(calculateMinDate());
    setArrivalDate(null);
    setArrivalTime(null);
    setDepartureDate(null);
    setDepartureTime(null);
    setShipmentDate(null);
    setShipmentTime(null);
    setainspectionDateTime(null);
    setaInspectionTime(null);
    setMaxInspectionDate(null);
    setInspectionLocation("");

    if (certificateNumber !== "" && typeofPermit !== "")
      fillLicenceDetails(certificateNumber, typeofTransaction, typeofPermit);
  };

  const handleTypeofPermitChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setTypeofPermit(event.target.value);
    var index = event.target.selectedIndex;
    var typeofPermit = event.target.options[index].text;

    setTypeofPermitText(typeofPermit);
    if (certificateNumber !== "" && typeofTransaction !== "")
      fillLicenceDetails(
        certificateNumber,
        typeofTransaction,
        event.target.value
      );
  };

  const handleCertificateNumberBlur = async (
    event: React.FocusEvent<HTMLInputElement>
  ) => {
    try {
      if (typeofPermit === "3" && event.target.value !== "") {
        setLoading(true);
        const tradenetResponse = await getTradenetPermitDetailsbyPermitNumber(
          event.target.value
        );

        if (tradenetResponse?.data) {
          setLoading(false);
          setCertificateNumberShowError(false);
          setDisableSubmit(false);
        } else {
          setLoading(false);
          setCertificateNumberShowError(true);
          setDisableSubmit(true);
        }
      }
      fillLicenceDetails(event.target.value, typeofTransaction, typeofPermit);
    } catch (error) {
      console.error("Error fetching TradeNet permit details:", error);
      setLoading(false);
      setCertificateNumberShowError(true);
      setDisableSubmit(true);
      message(
        NotifyType.Error,
        "Failed to fetch TradeNet permit details. Please try again."
      );
    }
  };

  const handleArrivalDateChange = (date: Date | null) => {
    if (isWeekend(date) || isHoliday(date)) {
      setisArrivalDateValid(false);
      setArrivalDate(null);
    } else {
      setArrivalDate(date);
      setisArrivalDateValid(true);
      setDisableInspectionDate(false);
      setArrivalTime(date);

      if (typeofTransaction === "4") {
        const maxDepartureDate = calculateMaxDepartureDate(date ?? new Date());

        setMaxDepartureDate(maxDepartureDate);

        const minDepartureTime = calculateDepartureMinTime(date ?? new Date());
        const maxDepartureTime = calculateDepartureMaxTime(date ?? new Date());

        setMinDepartureTime(minDepartureTime ?? new Date());
        setMaxDepartureTime(maxDepartureTime ?? new Date());
        setDepartureDate(null);
        setDepartureTime(null);
      }

      if (date !== null) {
        const inspectionTime = addHours(date, +2);

        const workingDate = findNextWorkingDay(inspectionTime);

        if (typeofTransaction === "4") {
          setMinInspectionTime(minDepartureTime ?? new Date());
          setMaxInspectionTime(maxDepartureTime ?? new Date());
          setMaxInspectionDate(workingDate);
        } else if (typeofTransaction === "1") {
          setMinInspectionDate(workingDate);
        }

        setainspectionDateTime(null);
        setaInspectionTime(null);

        SetInspectionTimeByLocationArrivalDate(
          date,
          workingDate ?? date,
          inspectionTime
        );
      }
    }
  };

  const handleArrivalTimeChange = (date: Date | null) => {
    setArrivalTime(date);
    if (date !== null) {
      if (typeofTransaction === "4") {
        let maxDepartureDate = calculateMaxDepartureDate(date ?? new Date());
        setMaxDepartureDate(maxDepartureDate);
        const minDepartureTime = calculateDepartureMinTime(date ?? new Date());
        const maxDepartureTime = calculateDepartureMaxTime(date ?? new Date());
        setMinDepartureTime(minDepartureTime ?? date);
        setMaxDepartureTime(maxDepartureTime ?? date);
        setDepartureDate(null);
        setDepartureTime(null);
      }
      setMinInspectionTime(setHours(setMinutes(setSeconds(date, 0), 0), 0));
      setMaxInspectionTime(setHours(setMinutes(setSeconds(date, 0), 59), 23));
      let inspectionTime = addHours(date, +2);
      let workingDate = findNextWorkingDay(inspectionTime);
      if (typeofTransaction === "4") {
        setMaxInspectionDate(workingDate);
      } else if (typeofTransaction === "1") {
        setMinInspectionDate(workingDate);
      }
      setainspectionDateTime(null);
      setaInspectionTime(null);
      SetInspectionTimeByLocationArrivalDate(
        date,
        workingDate ?? date,
        inspectionTime
      );
    }
  };

  const ChangeMinInspectionDate = (
    arrivalTime: Date | null,
    date: Date | null,
    location?: string
  ) => {
    let inspectionTime = arrivalTime != null ? addHours(arrivalTime, 2) : null;
    let inspectionLimit =
      date != null ? getMaxInspectionTime(date, location) : null;
    if (
      inspectionTime != null &&
      inspectionLimit != undefined &&
      inspectionLimit != null &&
      inspectionTime < inspectionLimit
    ) {
      setaInspectionTime(inspectionTime);
      setMinInspectionTime(inspectionTime);
      setainspectionDateTime(date);
    } else {
      var minTime = getMinInspectionTime(date, location);
      if (minTime != undefined) {
        setaInspectionTime(minTime);
        setMinInspectionTime(minTime);
      }
      if (date !== null) {
        // ChangeMinInspectionDate(arrivalDate);
        let adjustedDate = date;
        adjustedDate = addOneDay(adjustedDate);

        while (isWeekend(adjustedDate) || isHoliday(adjustedDate)) {
          adjustedDate = addOneDay(adjustedDate);
        }
        setMinInspectionDate(adjustedDate);
        setainspectionDateTime(adjustedDate);
        var minTime = getMinInspectionTime(adjustedDate);
        if (minTime != undefined) setaInspectionTime(minTime);
      }
    }
  };

  const findNextWorkingDay = (date: Date | null): Date | null => {
    if (!date) return null;

    if (!isWeekend(date) && !isHoliday(date)) {
      return date; // Base case: date is a working day
    }

    // Recursive case: move to the next day and check again
    const nextDay = new Date(date);
    nextDay.setDate(date.getDate() + 1);

    return findNextWorkingDay(nextDay);
  };

  const findPreviousWorkingDay = (date: Date | null): Date | null => {
    if (!date) return null;

    if (!isWeekend(date) && !isHoliday(date)) {
      return date; // Base case: date is a working day
    }

    // Recursive case: move to the next day and check again
    const nextDay = new Date(date);
    nextDay.setDate(date.getDate() - 1);

    return findPreviousWorkingDay(nextDay);
  };

  const findInspectionTimeFromShipmentDate = (
    inspectionTime: Date,
    minInspectionTime: Date,
    maxInspectionTime: Date
  ): Date => {
    // Check if inspectionTime is within the range
    if (
      isAfter(inspectionTime, minInspectionTime) &&
      isBefore(inspectionTime, maxInspectionTime)
    ) {
      return inspectionTime;
    } else if (isAfter(inspectionTime, minInspectionTime)) {
      return maxInspectionTime;
    } else if (isBefore(inspectionTime, maxInspectionTime)) {
      return minInspectionTime;
    } else {
      return inspectionTime;
    }
  };

  const findInspectionTimeFromArrivalDate = (
    inspectionTime: Date,
    minInspectionTime: Date,
    maxInspectionTime: Date
  ): Date => {
    // Check if inspectionTime is within the range
    if (
      isAfter(inspectionTime, minInspectionTime) &&
      isBefore(inspectionTime, maxInspectionTime)
    ) {
      return inspectionTime;
    } else if (isBefore(inspectionTime, maxInspectionTime)) {
      return minInspectionTime;
    } else {
      return maxInspectionTime;
    }
  };

  const SetInspectionTimeByLocationShipmentDate = (
    date: Date,
    workingDate: Date,
    inspectionTime: Date,
    location?: string,
    selectedInspectDate?: Date | null
  ) => {
    //const day = date.getDay();
    const day = (selectedInspectDate ?? date).getDay();
    const loc = location != undefined ? location : inspectionLocation;
    if (loc === "1") {
      if (day === 1 || day === 2) {
        // Set minimum inspection time to 9:00 AM
        let minInspectionTime = setHours(
          setMinutes(setSeconds(workingDate, 0), 0),
          9
        );
        setMinInspectionTime(minInspectionTime);

        // Set maximum inspection time to 5:00 PM
        let maxInspectionTime = setHours(
          setMinutes(setSeconds(workingDate, 0), 0),
          17
        );
        setMaxInspectionTime(maxInspectionTime);
        inspectionTime = findInspectionTimeFromShipmentDate(
          inspectionTime,
          minInspectionTime,
          maxInspectionTime
        );
        setaInspectionTime(inspectionTime);
      }
      if (day === 3 || day === 4 || day === 5) {
        // Set minimum inspection time to 9:00 AM
        let minInspectionTime = setHours(
          setMinutes(setSeconds(workingDate, 0), 0),
          9
        );
        setMinInspectionTime(minInspectionTime);

        // Set maximum inspection time to 8:00 PM
        let maxInspectionTime = setHours(
          setMinutes(setSeconds(workingDate, 0), 0),
          20
        );
        setMaxInspectionTime(maxInspectionTime);
        inspectionTime = findInspectionTimeFromShipmentDate(
          inspectionTime,
          minInspectionTime,
          maxInspectionTime
        );
        setaInspectionTime(inspectionTime);
      }
      {/*if (day === 6) {
        // Set minimum inspection time to 10:00 AM
        let minInspectionTime = setHours(
          setMinutes(setSeconds(workingDate, 0), 0),
          10
        );
        setMinInspectionTime(minInspectionTime);

        // Set maximum inspection time to 8:30 PM
        let maxInspectionTime = setHours(
          setMinutes(setSeconds(workingDate, 0), 30),
          20
        );
        setMaxInspectionTime(maxInspectionTime);
        inspectionTime = findInspectionTimeFromShipmentDate(
          inspectionTime,
          minInspectionTime,
          maxInspectionTime
        );
        setaInspectionTime(inspectionTime);
      }*/}
    }
    if (loc === "2") {
      // Set minimum inspection time to 5:00 AM
      let minInspectionTime = setHours(
        setMinutes(setSeconds(workingDate, 0), 0),
        5
      );
      setMinInspectionTime(minInspectionTime);

      // Set maximum inspection time to 11:00 AM
      let maxInspectionTime = setHours(
        setMinutes(setSeconds(workingDate, 0), 0),
        11
      );
      setMaxInspectionTime(maxInspectionTime);
      inspectionTime = findInspectionTimeFromShipmentDate(
        inspectionTime,
        minInspectionTime,
        maxInspectionTime
      );
      setaInspectionTime(inspectionTime);
    }
  };

  const SetInspectionTimeByLocationArrivalDate = (
    date: Date,
    workingDate: Date,
    inspectionTime: Date,
    location?: string,
    selectedInspectionDate?: Date | null
  ) => {
    //const day = date.getDay();
    const day = (selectedInspectionDate ?? date).getDay();
    const loc = location != undefined ? location : inspectionLocation;
    if (loc === "1") {
      if (day === 1 || day === 2) {
        // Set minimum inspection time to 9:00 AM
        let minInspectionTime = setHours(
          setMinutes(setSeconds(workingDate, 0), 0),
          9
        );
        setMinInspectionTime(minInspectionTime);

        // Set maximum inspection time to 5:00 PM
        let maxInspectionTime = setHours(
          setMinutes(setSeconds(workingDate, 0), 0),
          17
        );
        setMaxInspectionTime(maxInspectionTime);
        inspectionTime = findInspectionTimeFromArrivalDate(
          inspectionTime,
          minInspectionTime,
          maxInspectionTime
        );
        setaInspectionTime(inspectionTime);
      }
      if (day === 3 || day === 4 || day === 5) {
        // Set minimum inspection time to 9:00 AM
        let minInspectionTime = setHours(
          setMinutes(setSeconds(workingDate, 0), 0),
          9
        );
        setMinInspectionTime(minInspectionTime);

        // Set maximum inspection time to 8:00 PM
        let maxInspectionTime = setHours(
          setMinutes(setSeconds(workingDate, 0), 0),
          20
        );
        setMaxInspectionTime(maxInspectionTime);
        inspectionTime = findInspectionTimeFromArrivalDate(
          inspectionTime,
          minInspectionTime,
          maxInspectionTime
        );
        setaInspectionTime(inspectionTime);
      }
      {/*if (day === 6) {
        // Set minimum inspection time to 10:00 AM
        let minInspectionTime = setHours(
          setMinutes(setSeconds(workingDate, 0), 0),
          10
        );
        setMinInspectionTime(minInspectionTime);

        // Set maximum inspection time to 8:30 PM
        let maxInspectionTime = setHours(
          setMinutes(setSeconds(workingDate, 0), 30),
          20
        );
        setMaxInspectionTime(maxInspectionTime);
        inspectionTime = findInspectionTimeFromArrivalDate(
          inspectionTime,
          minInspectionTime,
          maxInspectionTime
        );
        setaInspectionTime(inspectionTime);
      }*/}
    }
    if (loc === "2") {
      // Set minimum inspection time to 5:00 AM
      let minInspectionTime = setHours(
        setMinutes(setSeconds(workingDate, 0), 0),
        5
      );
      setMinInspectionTime(minInspectionTime);

      // Set maximum inspection time to 11:00 AM
      let maxInspectionTime = setHours(
        setMinutes(setSeconds(workingDate, 0), 0),
        11
      );
      setMaxInspectionTime(maxInspectionTime);
      inspectionTime = findInspectionTimeFromArrivalDate(
        inspectionTime,
        minInspectionTime,
        maxInspectionTime
      );
      setaInspectionTime(inspectionTime);
    }
  };

  const SetInspectionTimeByInspectionDate = (
    date: Date,
    workingDate: Date,
    inspectionTime: Date,
    location?: string
  ) => {
    const day = date.getDay();
    const loc = location != undefined ? location : inspectionLocation;
    if (loc === "1") {
      if (day === 1 || day === 2) {
        // Set minimum inspection time to 9:00 AM
        let minInspectionTime = setHours(
          setMinutes(setSeconds(workingDate, 0), 0),
          9
        );
        setMinInspectionTime(minInspectionTime);

        // Set maximum inspection time to 5:00 PM
        let maxInspectionTime = setHours(
          setMinutes(setSeconds(workingDate, 0), 0),
          17
        );
        setMaxInspectionTime(maxInspectionTime);
        //setaInspectionTime(inspectionTime);
      }
      if (day === 3 || day === 4 || day === 5) {
        // Set minimum inspection time to 9:00 AM
        let minInspectionTime = setHours(
          setMinutes(setSeconds(workingDate, 0), 0),
          9
        );
        setMinInspectionTime(minInspectionTime);

        // Set maximum inspection time to 8:00 PM
        let maxInspectionTime = setHours(
          setMinutes(setSeconds(workingDate, 0), 0),
          20
        );
        setMaxInspectionTime(maxInspectionTime);
        //setaInspectionTime(inspectionTime);
      }
      {/*if (day === 6) {
        // Set minimum inspection time to 10:00 AM
        let minInspectionTime = setHours(
          setMinutes(setSeconds(workingDate, 0), 0),
          10
        );
        setMinInspectionTime(minInspectionTime);

        // Set maximum inspection time to 8:30 PM
        let maxInspectionTime = setHours(
          setMinutes(setSeconds(workingDate, 0), 30),
          20
        );
        setMaxInspectionTime(maxInspectionTime);
        //setaInspectionTime(inspectionTime);
      }*/}
    }
    if (loc === "2") {
      // Set minimum inspection time to 5:00 AM
      let minInspectionTime = setHours(
        setMinutes(setSeconds(workingDate, 0), 0),
        5
      );
      setMinInspectionTime(minInspectionTime);

      // Set maximum inspection time to 11:00 AM
      let maxInspectionTime = setHours(
        setMinutes(setSeconds(workingDate, 0), 0),
        11
      );
      setMaxInspectionTime(maxInspectionTime);
      //setaInspectionTime(inspectionTime);
    }
  };

  // const handleShipmentDateChange = (date: Date | null) => {
  //   if (isWeekend(date) || isHoliday(date)) {
  //     // If the selected date is a weekend or a holiday, prevent updating the state
  //     setisShipmentDateValid(false);
  //     setShipmentDate(null);
  //   } else {
  //     setShipmentDate(date);
  //     setisShipmentDateValid(true);
  //     setDisableInspectionDate(false);
  //     setShipmentTime(date);
  //     if (date !== null) {
  //       setMinInspectionTime(setHours(setMinutes(setSeconds(date, 0), 0), 0));
  //       setMaxInspectionTime(setHours(setMinutes(setSeconds(date, 0), 59), 23));
  //       let inspectionTime = addHours(date, -2);
  //       let workingDate = findPreviousWorkingDay(inspectionTime);
  //       setMaxInspectionDate(workingDate);
  //       setainspectionDateTime(null);
  //       setaInspectionTime(null);
  //       SetInspectionTimeByLocationShipmentDate(
  //         date,
  //         workingDate ?? date,
  //         inspectionTime
  //       );
  //     }
  //   }
  // };
  const handleShipmentDateChange = (date: Date | null) => {
    if (isWeekend(date) || isHoliday(date)) {
      setisShipmentDateValid(false);
      setShipmentDate(null);
    } else {
      // Preserve existing time if it exists
      const newDate = date ? new Date(date) : null;
      if (newDate && shipmentTime) {
        newDate.setHours(shipmentTime.getHours());
        newDate.setMinutes(shipmentTime.getMinutes());
      }
      setShipmentDate(newDate);
      setisShipmentDateValid(true);
      setDisableInspectionDate(false);

      if (newDate !== null) {
        setMinInspectionTime(
          setHours(setMinutes(setSeconds(newDate, 0), 0), 0)
        );
        setMaxInspectionTime(
          setHours(setMinutes(setSeconds(newDate, 0), 59), 23)
        );
        let inspectionTime = addHours(newDate, -2);
        let workingDate = findPreviousWorkingDay(inspectionTime);
        setMaxInspectionDate(workingDate);
        setainspectionDateTime(null);
        setaInspectionTime(null);
        SetInspectionTimeByLocationShipmentDate(
          newDate,
          workingDate ?? newDate,
          inspectionTime,
          undefined,
          shipmentDate
        );
      }
    }
  };
  // const handleShipmentTimeChange = (date: Date | null) => {
  //   setShipmentTime(date);
  //   if (date !== null) {
  //     setMinInspectionTime(setHours(setMinutes(setSeconds(date, 0), 0), 0));
  //     setMaxInspectionTime(setHours(setMinutes(setSeconds(date, 0), 59), 23));
  //     let inspectionTime = addHours(date, -2);
  //     let workingDate = findPreviousWorkingDay(inspectionTime);
  //     setMaxInspectionDate(workingDate);
  //     setainspectionDateTime(null);
  //     setaInspectionTime(null);
  //     SetInspectionTimeByLocationShipmentDate(
  //       workingDate ?? date,
  //       workingDate ?? date,
  //       inspectionTime
  //     );
  //   }
  // };
  const handleShipmentTimeChange = (time: Date | null) => {
    setShipmentTime(time);
    if (time && shipmentDate) {
      // Combine with existing date
      const combinedDateTime = new Date(shipmentDate);
      combinedDateTime.setHours(time.getHours());
      combinedDateTime.setMinutes(time.getMinutes());

      setMinInspectionTime(
        setHours(setMinutes(setSeconds(combinedDateTime, 0), 0), 0)
      );
      setMaxInspectionTime(
        setHours(setMinutes(setSeconds(combinedDateTime, 0), 59), 23)
      );
      let inspectionTime = addHours(combinedDateTime, -2);
      let workingDate = findPreviousWorkingDay(inspectionTime);
      setMaxInspectionDate(workingDate);
      setainspectionDateTime(null);
      setaInspectionTime(null);
      SetInspectionTimeByLocationShipmentDate(
        workingDate ?? combinedDateTime,
        workingDate ?? combinedDateTime,
        inspectionTime
      );
    }
  };
  const handleInspectionDateChange = (date: Date | null) => {
    if (isWeekend(date) || isHoliday(date)) {
      // If the selected date is a weekend or a holiday, prevent updating the state
      setainspectionDateTime(null);
    } else {
      setainspectionDateTime(date);
      setaInspectionTime(date);
      if (date !== null) {
        if (typeofTransaction === "3") {
          setMinInspectionTime(setHours(setMinutes(setSeconds(date, 0), 0), 0));
          setMaxInspectionTime(
            setHours(setMinutes(setSeconds(date, 0), 59), 23)
          );
          setaInspectionTime(null);
          SetInspectionTimeByInspectionDate(date, date, date);
        } else {
          setMinInspectionTime(setHours(setMinutes(setSeconds(date, 0), 0), 0));
          setMaxInspectionTime(
            setHours(setMinutes(setSeconds(date, 0), 59), 23)
          );
          if (shipmentTime != null) {
            let inspectionTime = addHours(shipmentTime, -2);
            let workingDate = findPreviousWorkingDay(inspectionTime);
            setaInspectionTime(workingDate);
            SetInspectionTimeByLocationShipmentDate(
              date,
              workingDate ?? date,
              inspectionTime,
              undefined,
              date
            );
          } else if (arrivalTime != null) {
            let inspectionTime = addHours(arrivalTime, +2);
            let workingDate = findNextWorkingDay(inspectionTime);
            setaInspectionTime(workingDate);
            SetInspectionTimeByLocationArrivalDate(
              date,
              workingDate ?? date,
              inspectionTime,
              undefined,
              date
            );
          }
        }
      }
    }
  };

  const handleInspectionTimeChange = (
    date: Date | null,
    event: SyntheticEvent<any, Event> | undefined
  ) => {
    setaInspectionTime(date);
    setInspectionTimeValid(true);
    if (date !== null && shipmentTime != null) {
      SetInspectionTimeByLocationShipmentDate(date, date, date, undefined, ainspectionDateTime);
    } else if (date !== null && arrivalTime != null) {
      SetInspectionTimeByLocationArrivalDate(date, date, date, undefined, ainspectionDateTime);
    }

    if (date !== null && typeofTransaction === "1" && arrivalTime !== null) {
      if (!isAfter(date, arrivalTime)) {
        setInspectionTimeValid(false);
      }
    } else if (
      date !== null &&
      typeofTransaction === "2" &&
      shipmentTime !== null
    ) {
      if (!isBefore(date, shipmentTime)) {
        setInspectionTimeValid(false);
      }
    }
    if (
      date !== null &&
      typeofTransaction === "4" &&
      arrivalTime !== null &&
      departureTime !== null
    ) {
      if (!isAfter(date, arrivalTime) && !isBefore(date, departureTime)) {
        setInspectionTimeValid(false);
      }
    }
  };

  const ChangeMaxInspectionDate = (
    shipmentTime: Date | null,
    date: Date | null
  ) => {
    let inspectionTime =
      shipmentTime != null ? addMinutes(shipmentTime, -120) : null;
    let inspectionLimit =
      inspectionTime != null ? getMinInspectionTime(inspectionTime) : null;
    if (
      inspectionTime != null &&
      inspectionLimit != undefined &&
      inspectionLimit != null &&
      inspectionTime > inspectionLimit
    ) {
      setaInspectionTime(inspectionTime);
      setMinInspectionTime(inspectionLimit);
      setMaxInspectionTime(inspectionTime);
      setMaxInspectionDate(inspectionTime);
      setainspectionDateTime(inspectionTime);
    } else {
      var maxTime = getMaxInspectionTime(inspectionTime);
      if (maxTime != undefined) {
        setaInspectionTime(maxTime);
        setMaxInspectionTime(maxTime);
      }
      if (date !== null) {
        let adjustedDate = date;
        adjustedDate = removeOneDay(adjustedDate);

        while (isWeekend(adjustedDate) || isHoliday(adjustedDate)) {
          adjustedDate = removeOneDay(adjustedDate);
        }
        setMaxInspectionDate(adjustedDate);
        setainspectionDateTime(adjustedDate);
      }
    }
  };

  const handleDepartureDateChange = (
    date: Date | null,
    event: SyntheticEvent<any, Event> | undefined
  ) => {
    if (isWeekend(date) || isHoliday(date)) {
      // If the selected date is a weekend or a holiday, prevent updating the state
      setisDepartureDateValid(false);
      setDepartureDate(null);
    } else {
      setDepartureDate(date);
      setMinInspectionDate(arrivalDate);
      setMaxInspectionDate(date);
      setDisableInspectionDate(false);
      const minDepartureTime = calculateDepartureMinTime(
        arrivalTime == date ? arrivalTime ?? new Date() : date ?? new Date()
      );
      const maxDepartureTime = calculateDepartureMaxTime(
        arrivalTime == date ? arrivalTime ?? new Date() : date ?? new Date()
      );
      setMinDepartureTime(minDepartureTime ?? new Date());
      setMaxDepartureTime(maxDepartureTime ?? new Date());
      setDepartureTime(null);
    }
  };

  const handleDepartureTimeChange = (
    date: Date | null,
    event: SyntheticEvent<any, Event> | undefined
  ) => {
    if (date) {
      setDepartureTime(date);
      let inspectionTime = addMinutes(date, -30);
      setMaxInspectionTime(inspectionTime);
    }
  };

  const smobileNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[0-9]+$/;

    if (pattern.test(value)) {
      setsMobileNo(value);
      if (value.length < 8) {
        setValidMobileNo(false);
      } else {
        setValidMobileNo(true);
      }
    } else {
      if (value === "") {
        setsMobileNo(value);
        setValidMobileNo(true);
      } else {
        setValidMobileNo(false);
      }
    }
  };

  const amobileNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[0-9]+$/;

    if (pattern.test(value)) {
      setaMobileNo(value);
      if (value.length < 8) {
        setValidaMobileNo(false);
      } else {
        setValidaMobileNo(true);
      }
    } else {
      if (value === "") {
        setaMobileNo(value);
        setValidaMobileNo(true);
      } else {
        setValidaMobileNo(false);
      }
    }
  };

  useEffect(() => {
    if (inspectionId != undefined) {
      setInspectionCaseId(inspectionId);
      setDisableInspectionDate(true);
      setDisableSubmit(true);
      try {
        const fetchDataToEdit = async () => {
          var response = null;

          response = await getInspectionById(inspectionId);
          if (response.data) {
            if (response.data.inspectionStatus === 1) {
              setDisableInspectionDate(false);
              setDisableSubmit(false);
            }
            if (response.data.typeOfCertificate != undefined)
              setTypeofPermit(response.data.typeOfCertificate);
            if (response.data.typeOfTransaction != undefined) {
              setTypeofTransaction(response.data.typeOfTransaction);
              typeofTransactionChange(response.data.typeOfTransaction);
            }
            if (response.data.certificateNumber != undefined)
              setCertificateNumber(response.data.certificateNumber);
            if (response.data.salutationId != undefined)
              setiSalutation(response.data.salutationId);
            setiApplicantName(response.data.name);
            if (response.data.mobileNo != undefined)
              setsMobileNo(response.data.mobileNo);
            if (response.data.email != undefined)
              setiEmail(response.data.email);

            if (response.data.authorizedPersonName != undefined)
              setAuthorizedPersonName(response.data.authorizedPersonName);
            if (response.data.contactEmailofAuthorizedPerson != undefined)
              setAuthPersonEmail(response.data.contactEmailofAuthorizedPerson);
            if (response.data.contactNumberofAuthorizedPerson != undefined) {
              setAuthPersonContactNumber(
                response.data.contactNumberofAuthorizedPerson.substring(0, 3)
              );
              setaMobileNo(
                response.data.contactNumberofAuthorizedPerson.substring(3)
              );
            }

            if (response.data.consignmentType != undefined)
              setConsignmentType(response.data.consignmentType);

            if (response.data.arrivalMethod != undefined)
              setArrivalMethod(response.data.arrivalMethod);
            if (response.data.flightNumber != undefined)
              setFlightNumber(response.data.flightNumber);
            if (response.data.vehicleNumber != undefined)
              setVehicleNumber(response.data.vehicleNumber);
            if (response.data.vessel != undefined)
              setVessel(response.data.vessel);
            if (response.data.shipInformation != undefined)
              setShipInfo(response.data.shipInformation);
            if (response.data.shipmentBy != undefined)
              setShipmentBy(response.data.shipmentBy);
            if (response.data.checkinofAnimal != undefined)
              setCheckinofAnimal(response.data.checkinofAnimal);
            if (response.data.stopoverPortDuration != undefined)
              setStopoverPortDuration(response.data.stopoverPortDuration);
            if (response.data.stopoverPortCountry != undefined)
              setStopoverPortCountry(response.data.stopoverPortCountry);
            if (response.data.seaportforInspection != undefined)
              setSeaPortforInspection(response.data.seaportforInspection);
            if (response.data.inspectionLocation != undefined)
              setInspectionLocation(response.data.inspectionLocation);

            // if (response.data.arrivalDate != undefined) {
            //   setArrivalDate(new Date(response.data.arrivalDate));
            // }

            if (response.data.arrivalDate != undefined) {
              const arrivalDate = new Date(response.data.arrivalDate);

              setArrivalDate(new Date(response.data.arrivalDate));

              handleArrivalDateChange(arrivalDate);
            }
            // if (response.data.arrivalTime != undefined) {
            //   let arrivalTime = getTimezoneOffset(
            //     new Date(response.data.arrivalTime)
            //   );
            //   setArrivalTime(arrivalTime);
            //   setInspectionTime(arrivalTime);
            // }
            // if (response.data.dateofShipment != undefined) {
            //   setShipmentDate(new Date(response.data.dateofShipment));
            // }
            if (response.data.arrivalTime != undefined) {
              const arrivalTime = getTimezoneOffset(
                new Date(response.data.arrivalTime)
              );
              setArrivalTime(arrivalTime);
              setInspectionTime(arrivalTime);
              handleArrivalTimeChange(arrivalTime);
            }
            if (response.data.dateofShipment != undefined) {
              const shipmentDate = new Date(response.data.dateofShipment);
              setShipmentDate(new Date(response.data.dateofShipment));
              if (!isWeekend(shipmentDate) && !isHoliday(shipmentDate)) {
                handleShipmentDateChange(shipmentDate);
              }
            }

            // if (response.data.timeofShipment != undefined) {
            //   let shipmentTime = getTimezoneOffset(
            //     new Date(response.data.timeofShipment)
            //   );
            //   setShipmentTime(shipmentTime);
            //   setInspectionTime(shipmentTime);
            // }
            if (response.data.timeofShipment != undefined) {
              const shipmentTime = getTimezoneOffset(
                new Date(response.data.timeofShipment)
              );
              setShipmentTime(shipmentTime);
              setInspectionTime(shipmentTime);
              handleShipmentTimeChange(shipmentTime);
            }
            if (response.data.departureDate != undefined) {
              setDepartureDate(new Date(response.data.departureDate));
            }

            if (response.data.departureTime != undefined) {
              let departureTime = getTimezoneOffset(
                new Date(response.data.departureTime)
              );
              setDepartureTime(departureTime);
              setInspectionTime(departureTime);
            }

            if (
              arrivalTime != null &&
              arrivalTime != undefined &&
              arrivalDate != null &&
              arrivalDate != undefined
            )
              ChangeMinInspectionDate(arrivalTime, arrivalDate);
            if (
              shipmentTime != null &&
              shipmentTime != undefined &&
              shipmentDate != null &&
              shipmentDate != undefined
            )
              ChangeMaxInspectionDate(shipmentTime, shipmentDate);

            if (response.data.insAppHarvestDate != undefined) {
              const inspectionDate = new Date(response.data.insAppHarvestDate);
              const dateOnly = new Date(
                inspectionDate.getFullYear(),
                inspectionDate.getMonth(),
                inspectionDate.getDate(),
                0,
                0,
                0
              );
              setainspectionDateTime(dateOnly);
            }
            if (response.data.insAppHarvestTime != undefined) {
              let date = getTimezoneOffset(
                new Date(response.data.insAppHarvestTime)
              );
              setaInspectionTime(date);
            }

            if (response.data.insAppRemarks != undefined)
              setaRemarks(response.data.insAppRemarks);
            if (response.data.insAppModeofContact != undefined)
              setaModeofContact(response.data.insAppModeofContact);
            if (response.data.insAppMobileNo != undefined)
              setaMobileNo(response.data.insAppMobileNo);
            if (response.data.portOfExit != undefined)
              setPortofExit(response.data.portOfExit);
            if (response.data.flightDetail != undefined)
              setFlightDetails(response.data.flightDetail);
            if (response.data.countryOfOrigin != undefined)
              setCountryOfOrigin(response.data.countryOfOrigin);
            if (response.data.countryOfDestination != undefined) {
              setCountryofDestination(response.data.countryOfDestination);
              setExportCountryofDestination(response.data.countryOfDestination);
            }
          } else {
            // API call failed
          }
          setCountries(countries);
          setIsLoading(false);
          if (inspectionmode === "view") {
            setViewMode(true);
            setamendMode(false);
            setDisableSubmit(true);
            setDisableInspectionDate(true);
          } else if (inspectionmode === "amend") {
            setViewMode(false);
            setamendMode(true);
            setDisableSubmit(false);
            setDisableInspectionDate(false);
          }
        };
        fetchDataToEdit();
      } catch (error) {
        setIsLoading(false);
      }
    }
  }, [inspectionId]);

  useEffect(() => {
    if (inputCountryRef.current) {
      inputCountryRef.current = false;
      const fetchData = async () => {
        const countries = await fetchCountryOptions();
        setCountries(countries);
        setIsLoading(false);
      };

      fetchData();
    }
  }, []);

  useEffect(() => {
    const fetchPorts = async () => {
      try {
        const response = await getPorts();
        if (response?.data) {
          setPorts(response.data);
        }
      } catch (error) {
        console.error("Error fetching ports:", error);
        message(NotifyType.Error, "Failed to fetch ports. Please try again.");
      }
    };

    fetchPorts();
  }, []);

  useEffect(() => {
    if (inputHolidayRef.current) {
      inputHolidayRef.current = false;

      const fetchHolidaysData = async () => {
        try {
          const holidaysData = await fetchHolidaysMaster();
          setHolidays(holidaysData);
        } catch (error) {
          console.error("Error fetching holidays data:", error);
          message(
            NotifyType.Error,
            "Failed to fetch holidays data. Please try again."
          );
        }
      };

      fetchHolidaysData();
    }
  }, []);

  const handleCountryofDestinationChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setCountryofDestination(event.target.value);
  };

  const handleExportCountryofDestinationChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setExportCountryofDestination(event.target.value);
  };

  const ahandleStopoverCountryChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setStopoverPortCountry(event.target.value);
  };

  // const handleInspectionLocationChange = (
  //   event: React.ChangeEvent<HTMLSelectElement>
  // ) => {
  //   var location = event.target.value;
  //   setInspectionLocation(location);
  //   if (location === "3") setHideOtherAppointedPlace(false);
  //   else {
  //     setHideOtherAppointedPlace(true);
  //   }

  //   if (typeofTransaction === "1" || typeofTransaction === "4") {
  //     if (arrivalDate !== null) {
  //       setMinInspectionTime(
  //         setHours(setMinutes(setSeconds(arrivalDate, 0), 0), 0)
  //       );
  //       setMaxInspectionTime(
  //         setHours(setMinutes(setSeconds(arrivalDate, 0), 59), 23)
  //       );
  //       let inspectionTime = addHours(arrivalTime ?? arrivalDate, +2);
  //       let workingDate = findNextWorkingDay(inspectionTime);
  //       if (typeofTransaction === "4") {
  //         setMaxInspectionDate(workingDate);
  //       } else if (typeofTransaction === "1") {
  //         setMinInspectionDate(workingDate);
  //       }
  //       setainspectionDateTime(null);
  //       setaInspectionTime(null);
  //       SetInspectionTimeByLocationArrivalDate(
  //         workingDate ?? arrivalDate,
  //         workingDate ?? arrivalDate,
  //         inspectionTime,
  //         location
  //       );
  //     }
  //   } else if (typeofTransaction === "2") {
  //     if (shipmentDate !== null) {
  //       setMinInspectionTime(
  //         setHours(setMinutes(setSeconds(shipmentDate, 0), 0), 0)
  //       );
  //       setMaxInspectionTime(
  //         setHours(setMinutes(setSeconds(shipmentDate, 0), 59), 23)
  //       );

  //       let inspectionTime = addHours(shipmentDate, -2);
  //       let workingDate = findNextWorkingDay(inspectionTime);
  //       setMaxInspectionDate(workingDate);
  //       setainspectionDateTime(null);
  //       setaInspectionTime(null);
  //       SetInspectionTimeByLocationShipmentDate(
  //         workingDate ?? inspectionTime,
  //         workingDate ?? inspectionTime,
  //         inspectionTime,
  //         location
  //       );
  //     }
  //   } else if (typeofTransaction === "3" && ainspectionDateTime !== null) {
  //     setMinInspectionTime(
  //       setHours(setMinutes(setSeconds(ainspectionDateTime, 0), 0), 0)
  //     );
  //     setMaxInspectionTime(
  //       setHours(setMinutes(setSeconds(ainspectionDateTime, 0), 59), 23)
  //     );
  //     setainspectionDateTime(null);
  //     setaInspectionTime(null);
  //     SetInspectionTimeByInspectionDate(
  //       ainspectionDateTime,
  //       ainspectionDateTime,
  //       ainspectionDateTime
  //     );
  //   }
  // };
  const handleInspectionLocationChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const location = event.target.value;
    setInspectionLocation(location);
    if (location === "3") {
      setHideOtherAppointedPlace(false);
    } else {
      setHideOtherAppointedPlace(true);
    }
    const getFullDateTime = (date: Date | null, time: Date | null) => {
      if (!date) return null;
      if (!time) return date;
      const combined = new Date(date);
      combined.setHours(time.getHours());
      combined.setMinutes(time.getMinutes());
      combined.setSeconds(0);
      combined.setMilliseconds(0);
      return combined;
    };

    if (typeofTransaction === "1" || typeofTransaction === "4") {
      const fullArrivalDate = getFullDateTime(arrivalDate, arrivalTime);
      if (fullArrivalDate) {
        setMinInspectionTime(
          setHours(setMinutes(setSeconds(fullArrivalDate, 0), 0), 0)
        );
        setMaxInspectionTime(
          setHours(setMinutes(setSeconds(fullArrivalDate, 0), 59), 23)
        );
        const inspectionTime = addHours(fullArrivalDate, +2);
        const workingDate = findNextWorkingDay(inspectionTime);
        if (typeofTransaction === "4") {
          setMaxInspectionDate(workingDate);
        } else if (typeofTransaction === "1") {
          setMinInspectionDate(workingDate);
        }

        setainspectionDateTime(null);
        setaInspectionTime(null);

        SetInspectionTimeByLocationArrivalDate(
          workingDate ?? fullArrivalDate,
          workingDate ?? fullArrivalDate,
          inspectionTime,
          location
        );
      }
    } else if (typeofTransaction === "2") {
      const fullShipmentDate = getFullDateTime(shipmentDate, shipmentTime);
      if (fullShipmentDate) {
        setMinInspectionTime(
          setHours(setMinutes(setSeconds(fullShipmentDate, 0), 0), 0)
        );
        setMaxInspectionTime(
          setHours(setMinutes(setSeconds(fullShipmentDate, 0), 59), 23)
        );

        const inspectionTime = addHours(fullShipmentDate, -2);
        const workingDate = findPreviousWorkingDay(inspectionTime);
        setMaxInspectionDate(workingDate);
        setainspectionDateTime(null);
        setaInspectionTime(null);
        SetInspectionTimeByLocationShipmentDate(
          workingDate ?? inspectionTime,
          workingDate ?? inspectionTime,
          inspectionTime,
          location
        );
      }
    } else if (typeofTransaction === "3" && ainspectionDateTime !== null) {
      setMinInspectionTime(
        setHours(setMinutes(setSeconds(ainspectionDateTime, 0), 0), 0)
      );
      setMaxInspectionTime(
        setHours(setMinutes(setSeconds(ainspectionDateTime, 0), 59), 23)
      );

      setainspectionDateTime(null);
      setaInspectionTime(null);

      SetInspectionTimeByInspectionDate(
        ainspectionDateTime,
        ainspectionDateTime,
        ainspectionDateTime
      );
    }
  };
  if (isLoading) {
    return <Loader />;
  }

  const fixTimezoneOffset = (date: Date | null): Date | null => {
    if (!date) return null;
    return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  };

  const getTimezoneOffset = (date: Date): Date | null => {
    const newDate = new Date(date);
    const userTimezoneOffset = Math.abs(newDate.getTimezoneOffset() * 60000);
    return new Date(newDate.getTime() - userTimezoneOffset);
  };

  async function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    submitRequest(2);
  }

  const submitRequest = async (inspectionSubmissionStatus: number) => {
    try {
      setSubmitted(true);
      const reCaptchaResponse = recaptchaRef.current?.getValue();
      let saltuation = isSalutationSelected();
      let modeofContact = isModeofContactSelected();
      setiSalutationSelected(saltuation);
      setaModeofContactSelected(modeofContact);
      if (!reCaptchaResponse) {
        // reCAPTCHA validation failed
        setIsCaptchaValid(false);
        message(
          NotifyType.Error,
          "Captcha verification failed. Please try again."
        );
        return;
      }

      if (!isValidDate) {
        message(NotifyType.Error, "Please select a valid inspection date");
        return;
      }

      if (!checkboxChecked) {
        message(NotifyType.Error, "Please check the Declaration checkbox");
        return;
      }

      if (!saltuation) {
        message(NotifyType.Error, "Please select a salutation");
        return;
      }

      if (!validEmail) {
        message(NotifyType.Error, "Please enter a valid email address");
        return;
      }

      if (!isInspectionTimeValid) {
        message(NotifyType.Error, "Please select a valid inspection time");
        return;
      }
      if (
        isValidDate &&
        checkboxChecked &&
        saltuation &&
        validEmail &&
        isInspectionTimeValid
      ) {
        var response = null;
        setSubmiting(true);
        inspectionRequestData.licenceeDetails.inspectionSubmissionStatus =
          inspectionSubmissionStatus;

        if (inspectionId != undefined || inspectionCaseId != "")
          response = await saveVetHealthInspection(
            inspectionCaseId,
            inspectionRequestData
          );
        else
          response = await saveVetHealthInspection("", inspectionRequestData);
        if (response.data.data) {
          setSubmiting(false);
          let path = `/vethealth-inspection-complete`;
          navigate(path, { state: { inspectionId: inspectionCaseId } });
        } else {
          setSubmiting(false);
          const errorMessage = response.data.message;
          setErrorMessage(errorMessage);
        }
      }
    } catch (error) {
      setSubmiting(false);
     if (error instanceof AxiosError) {
               setErrorMessage(
                 error.response?.data?.Message ||
                   "Error occurred during the search. Please try again"
               );
             } else {
               setErrorMessage(
                 "Error occurred during the search. Please try again."
               );
             }
             console.error(error);
    }
  };

  (function () {
    

    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    var forms = document.querySelectorAll(".needs-validation");

    // Loop over them and prevent submission
    Array.prototype.slice.call(forms).forEach(function (form) {
      form.addEventListener(
        "submit",
        function (event: any) {
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }

          form.classList.add("was-validated");
        },
        false
      );
    });
  })();
  // Include the applicantName value in your API request
  // Prepare the request payload
  const inspectionRequestData: IVetHealthInspectionRequest = {
    licenceeDetails: {
      typeOfCertificate: typeofPermit,
      certificateNumber: certificateNumber,
      typeOfTransaction: typeofTransaction,
      salutation: isalutation,
      name: iapplicantName,
      nric: "",
      aquasMembership: "",
      aquasMembershipNumber: "",
      uen: "",
      companyName: "",
      applicantAddressType: "",
      ApplicantMobileNo: imobilecode + smobileNo,
      ApplicantEmail: iemail,
      applicantTypeofPremises: "",
      applicantBlockHouseNumber: "",
      applicantStreetName: "",
      applicantFloorNumber: "",
      applicantUnitNumber: "",
      applicantBuildingName: "",
      applicantPostalCode: "",
      applicantCountry: "",
      orgAddressType: "",
      orgTypeofPremises: "",
      orgBlockHouseNumber: "",
      orgStreetName: "",
      orgFloorNumber: "",
      orgUnitNumber: "",
      orgBuildingName: "",
      orgPostalCode: "",
      orgCountry: "",
      authorizedPersonName: authorizedPersonName,
      authPersonEmail: authPersonEmail,
      authPersonContactNumber: authPersonContactNumber + amobileNo,
      inspectionSubmissionStatus: 1,
    },
    consignmentDetails: {
      consignmentType: consignmentType,
      warehouseAddressType: "",
      warehouseTypeofPremises: "",
      warehouseBlockHouseNumber: "",
      warehouseStreetName: "",
      warehouseFloorNumber: "",
      warehouseUnitNumber: "",
      warehouseBuildingName: "",
      warehousePostalCode: "",
      warehouseCountry: "",
      arrivalMethod: arrivalMethod,
      shipmentBy: shipmentBy,
      flightNumber: flightNumber,
      vehicleNumber: vehicleNumber,
      vessel: vessel,
      shipInformation: shipInfo,
      arrivalDate: fixTimezoneOffset(arrivalDate),
      arrivalTime: fixTimezoneOffset(arrivalTime) ?? null,
      shipmentDate: fixTimezoneOffset(shipmentDate),
      shipmentTime: fixTimezoneOffset(shipmentTime) ?? null,
      remarks: aRemarks,
      checkinOfAnimal: checkinofAnimal,
      stopoverPOrtCountry: stopoverPortCountry,
      stopoverPortDuration: stopoverPortDuration,
      dateOfInspection: fixTimezoneOffset(ainspectionDateTime),
      timeOfInspection: fixTimezoneOffset(ainspectionTime) ?? null,
      inspectionLocation: inspectionLocation,
      otherAppointedPlace: otherAppointedPlace,
      countryOfDestination:
        typeofTransaction === "4"
          ? countryofDestination
          : exportCountryofDestination,
      countryOfOrigin: countryOfOrigin,
      seaportforInspection: seaPortforInspection,
      portOfExit: portofExit,
      flightDetails: flightDetails,
      departureDate: fixTimezoneOffset(departureDate),
      departureTime: fixTimezoneOffset(departureTime) ?? null,
    },
    userInformation: {
      name: user?.name,
      idType: user?.idType,
      idNo: user?.idNo,
      email: user?.email,
      contactNo: user?.contactNo,
      companyName: user?.companyName,
      uen: user?.uen,
      registeredAddress: user?.registeredAddresses?.[0],
    },
  };

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    setiEmail(value);
    if (pattern.test(value)) {
      setValidEmail(true);
    } else {
      if (value === "") {
        setValidEmail(true);
      } else {
        setValidEmail(false);
      }
    }
  };

  const handleAuthPersonEmailChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value } = event.target;
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    setAuthPersonEmail(value);
    if (pattern.test(value)) {
      setValidAuthEmail(true);
    } else {
      if (value === "") {
        setValidAuthEmail(true);
      } else {
        setValidAuthEmail(false);
      }
    }
  };

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckboxChecked(event.target.checked);
  };

  const isSalutationSelected = () => {
    return isalutation !== null && isalutation !== "0";
  };
  const isModeofContactSelected = () => {
    return aModeofContact !== null && aModeofContact !== 0;
  };

  const handleNewReg = () => {
    window.location.reload();
  };

  return (
    <>
      <div className="inst-cnt mb-2">
        <p>Days and Time of Operation:</p>
        <ul className="csp-list-disc">
          <li>
            <label>Changi Animal and Plant Quarantine (CAPQ)</label>
            <label>
              Monday and Tuesday from 09:00 AM to 05:00 PM.{" "}
            </label>
            <label>Wednesday, Thursday and Friday from 09:00 AM to 08:00 PM. </label>
            <label>Saturday, Sunday and Public Holidays Closed.</label>
            <label>Closed for Lunch from 01:00 PM to 02:00 PM.</label>
          </li>
          <li>
            <label>Tuas Checkpoint </label>
            <label>Monday to Saturday From 5:00 AM to 11:00 AM.</label>
            <label>Closed on Sundays.</label>
          </li>
        </ul>
      </div>
      <div className="row">
        <div className="col-lg-9">
          <h2>Declaration</h2>
        </div>
        <div className="col-lg-3">
          <button
            className="btn btn-success d-block"
            onClick={() => handleNewReg()}
          >
            New Registration
          </button>
        </div>
      </div>
      <div className="inst-cnt mb-2">
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            checked={checkboxChecked}
            onChange={handleCheckboxChange}
            id="flexCheckDefault"
            required
          />
          <label className="form-check-label" htmlFor="flexCheckDefault">
            I certify that the information given is true and complete to the
            best of my knowledge.
          </label>
          {submitted && !checkboxChecked && (
            <p className="error-message">
              Please confirm the declaration checkbox
            </p>
          )}
        </div>
      </div>
      <h2 className="pb-2">Registration</h2>
      <div className="inst-cnt mt-4 mb-2">
        <span className="est-time">
          <i className="fas fa-clock"></i> Estimated time to complete: 15 mins
        </span>
      </div>
      <form
        className="row g-3 needs-validation"
        onSubmit={handleSubmit}
        noValidate
      >
        <h2 className="pb-0">User Information</h2>
        <div className="inst-cnt mt-4 mb-2">
          <div className="row">
            <div className="col-lg-6 row">
              <div className="col-md-5">
                <label htmlFor="name" className="form-label mb-2">
                  Name :
                </label>
              </div>
              <div className="col-md-7">
                <label className="form-label mb-2 fw-bold">{user.name}</label>
              </div>
            </div>
            <div className="col-lg-6 row">
              <div className="col-md-4">
                <label htmlFor="name" className="form-label mb-2 mr-10">
                  NRIC :
                </label>
              </div>
              <div className="col-md-8">
                <label className="form-label mb-2 fw-bold">{user.idNo}</label>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 row">
              <div className="col-md-5">
                <label htmlFor="name" className="form-label mb-2">
                  Mobile Number :
                </label>
              </div>
              <div className="col-md-7">
                <label className="form-label mb-2 fw-bold">
                  {user.contactNo}
                </label>
              </div>
            </div>
            <div className="col-lg-6 row">
              <div className="col-md-4">
                <label htmlFor="name" className="form-label mb-2 mr-10">
                  Email :
                </label>
              </div>
              <div className="col-md-8">
                <label className="form-label mb-2 fw-bold">{user.email}</label>
              </div>
            </div>
          </div>
          <div className="row">
            <label htmlFor="name" className="form-label mb-2 fw-bold">
              Address
            </label>
          </div>
          <div className="row">
            <div className="col-lg-6 row">
              <div className="col-md-5">
                <label htmlFor="name" className="form-label mb-2">
                  Block/House Number :
                </label>
              </div>
              <div className="col-md-7">
                <label className="form-label mb-2 fw-bold">
                  {user.registeredAddresses?.[0]?.blockHouseNo}
                </label>
              </div>
            </div>
            <div className="col-lg-6 row">
              <div className="col-md-4">
                <label htmlFor="name" className="form-label mb-2 mr-10">
                  Floor Number :
                </label>
              </div>
              <div className="col-md-8">
                <label className="form-label mb-2 fw-bold">
                  {user.registeredAddresses?.[0]?.floorLevel}
                </label>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 row">
              <div className="col-md-5">
                <label htmlFor="name" className="form-label mb-2">
                  Street Name :
                </label>
              </div>
              <div className="col-md-7">
                <label className="form-label mb-2 fw-bold">
                  {user.registeredAddresses?.[0]?.streetName}
                </label>
              </div>
            </div>
            <div className="col-lg-6 row">
              <div className="col-md-4">
                <label htmlFor="name" className="form-label mb-2 mr-10">
                  Unit Number :
                </label>
              </div>
              <div className="col-md-8">
                <label className="form-label mb-2 fw-bold">
                  {user.registeredAddresses?.[0]?.unit}
                </label>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 row">
              <div className="col-md-5">
                <label htmlFor="name" className="form-label mb-2">
                  Building Name :
                </label>
              </div>
              <div className="col-md-7">
                <label className="form-label mb-2 fw-bold">
                  {user.registeredAddresses?.[0]?.buildingName}
                </label>
              </div>
            </div>
            <div className="col-lg-6 row">
              <div className="col-md-4">
                <label htmlFor="name" className="form-label mb-2 mr-10">
                  Postal Code :
                </label>
              </div>
              <div className="col-md-8">
                <label className="form-label mb-2 fw-bold">
                  {user.registeredAddresses?.[0]?.postalCode}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div
          className="passport-details hidden csp-display-block"
          id="passport"
        >
          <div className="inst-cnt mt-2">
            <div className="mb-3 position-relative">
              <label htmlFor="sapplicantName" className="form-label mb-2">
                Type of Transaction <span className="star">*</span>{" "}
              </label>
              <select
                className="form-select"
                aria-label="Default select example"
                id="typeofTransaction"
                value={typeofTransaction}
                onChange={handleTypeofTransactionChange}
                disabled={viewMode || amendMode}
                required
              >
                <option value="" disabled selected hidden>
                  Select Type of Transaction
                </option>
                <option value="1">Import</option>
                <option value="2">Export</option>
                <option value="4">Transhipment</option>
                <option value="3">Dragonfish Pre-export Inspection</option>
              </select>
              <span
                className="star csp-abs-ml-100-mt--30"
              >
                *
              </span>
              <div className="invalid-feedback mb-3">
                Please provide an Type of Transaction.
              </div>
            </div>
            {showFormFields && (
              <div>
                <div className="mb-3 position-relative">
                  <label htmlFor="sapplicantName" className="form-label mb-2">
                    Type of Permit/Licence <span className="star">*</span>{" "}
                  </label>
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    id="typeofPermit"
                    value={typeofPermit}
                    onChange={handleTypeofPermitChange}
                    disabled={viewMode || amendMode}
                    required
                  >
                    <option value="" disabled selected hidden>
                      Select Type of Permit/Licence
                    </option>
                    {typeofTransaction !== "3" && (
                      <option value="1">AVS Licence</option>
                    )}
                    {(typeofTransaction === "1" ||
                      typeofTransaction === "3") && (
                      <option value="2">CITES PERMIT</option>
                    )}
                  </select>
                  <span
                    className="star csp-abs-ml-100-mt--30"
                  >
                    *
                  </span>
                  <div className="invalid-feedback mb-3">
                    Please provide an Type of Permit/Licence.
                  </div>
                </div>
                <div className="mb-2">
                  <label
                    htmlFor="certificateNumber"
                    className="form-label mb-2"
                  >
                    Permit/Licence Number <span className="star">*</span>{" "}
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="certificateNumber"
                    placeholder="Permit/Licence Number"
                    value={certificateNumber}
                    maxLength={30}
                    onChange={(event) =>
                      setCertificateNumber(event.target.value)
                    }
                    onBlur={handleCertificateNumberBlur}
                    disabled={viewMode || amendMode}
                    required
                  />
                  <div className="invalid-feedback">
                    Please provide a Permit/Licence Number.
                  </div>
                  {certificateNumberShowError && apiErrorMessage && (
                    <div className="error-message row">{apiErrorMessage}</div>
                  )}
                  {loading && <Loader />}
                </div>
                {showOtherFields && (
                  <div className="mb-2">
                    <label
                      htmlFor="consignmentType"
                      className="form-label mb-2"
                    >
                      Consignment Type
                    </label>
                    <select
                      className="form-select"
                      aria-label="Default select example"
                      id="consignmentType"
                      value={consignmentType}
                      disabled={viewMode || amendMode}
                      onChange={(event) =>
                        setConsignmentType(event.target.value)
                      }
                    >
                      <option value="" disabled selected hidden>
                        Select Consignment Type
                      </option>
                      <option value="1">Veterinary Biologics</option>
                      <option value="2">Animal Products</option>
                      <option value="3">Animals</option>
                    </select>
                    <span
                      className="star csp-abs-ml-100-mt--30"
                    >
                      *
                    </span>
                    <div className="invalid-feedback mb-3">
                      Please select Consignment type.
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
          {showFormFields && (
            <div>
              <h2 className="pb-0">Personal Information</h2>
              <div className="inst-cnt mt-2">
                <div className="mb-2">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className={`form-label mb-2 ${
                      !isSalutationSelected() ? "required" : ""
                    }`}
                  >
                    Salutation <span className="star">*</span>{" "}
                  </label>
                  <div>
                    {salutationOptions.map((option) => (
                      <div className="form-check" key={option.id}>
                        <input
                          className="form-check-input"
                          type="radio"
                          value={option.id}
                          checked={isalutation === option.id}
                          disabled={viewMode || amendMode}
                          onChange={(event) =>
                            setiSalutation(event.target.value)
                          }
                        />
                        <label key={option.id} className="form-check-label">
                          {option.name}
                        </label>
                      </div>
                    ))}
                  </div>
                  {submitted && !isSalutationSelected() && (
                    <div className="invalid-feedback">
                      Please select a Salutation.
                    </div>
                  )}
                </div>
                <div className="mb-2">
                  <label htmlFor="sapplicantName" className="form-label mb-2">
                    Name of Applicant <span className="star">*</span>{" "}
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="sapplicantName"
                    placeholder="Type Applicant Name as per NRIC / Passport"
                    value={iapplicantName}
                    maxLength={255}
                    onChange={(event) => setiApplicantName(event.target.value)}
                    disabled={viewMode || amendMode}
                    required
                  />
                  <div className="invalid-feedback">
                    Please provide a Applicant Name.
                  </div>
                </div>
                <div className="mb-2">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-2"
                  >
                    Mobile Number <span className="star">*</span>
                  </label>
                  <div className="row">
                    <div className="col-md-2">
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        id="smobilecode"
                        value={imobilecode}
                        onChange={(e) => setiMobileCode(e.target.value)}
                        disabled={viewMode || amendMode}
                        required
                      >
                        {countryMobileCodes.map((code: any) => (
                          <option key={code} value={code}>
                            {code}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-10">
                      <input
                        type="text"
                        aria-describedby="emailHelp"
                        className="form-control"
                        id="smobileNo"
                        placeholder=""
                        pattern="[0-9]+"
                        value={smobileNo}
                        onChange={smobileNoHandler}
                        maxLength={12}
                        disabled={viewMode || amendMode}
                        required
                      />
                      <div className="invalid-feedback">
                        Please provide a mobile.
                      </div>
                      {!validMobileNo && (
                        <div className="invalid-feedback">
                          Invalid mobile no. eg. +6591234567
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="mb-2">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-2"
                  >
                    Email<span className="star">*</span>
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="semail"
                    value={iemail}
                    maxLength={255}
                    onChange={handleEmailChange}
                    placeholder="Enter email"
                    disabled={viewMode || amendMode}
                    required
                  />
                  <div className="invalid-feedback">
                    Please provide a email.
                  </div>
                  {!validEmail && (
                    <p className="error-message">
                      Invalid email format. eg. abc@de.lk
                    </p>
                  )}
                </div>
                {!showOtherFields && (
                  <div>
                    <div className="mb-2">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        Authorized Person Name<span className="star">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="authPersonName"
                        value={authorizedPersonName}
                        maxLength={255}
                        onChange={(event) =>
                          setAuthorizedPersonName(event.target.value)
                        }
                        placeholder="Enter Authorized Person Name"
                        disabled={viewMode}
                        required
                      />
                      <div className="invalid-feedback">
                        Please provide Authorized Person Name.
                      </div>
                    </div>
                    <div className="mb-2">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        Contact Email of Authorized Person
                        <span className="star">*</span>
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        id="authPersonEmail"
                        value={authPersonEmail}
                        maxLength={255}
                        onChange={handleAuthPersonEmailChange}
                        placeholder="Enter email"
                        disabled={viewMode}
                        required
                      />
                      <div className="invalid-feedback">
                        Please provide a email.
                      </div>
                      {!validAuthEmail && (
                        <p className="error-message">
                          Invalid email format. eg. abc@de.lk
                        </p>
                      )}
                    </div>
                    <div className="mb-2">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        Contact Number of Authorized Person{" "}
                        <span className="star">*</span>
                      </label>

                      <div className="row">
                        <div className="col-md-2">
                          <select
                            className="form-select"
                            aria-label="Default select example"
                            id="amobilecode"
                            value={authPersonContactNumber}
                            onChange={(e) =>
                              setAuthPersonContactNumber(e.target.value)
                            }
                            disabled={viewMode}
                            required
                          >
                            {countryMobileCodes.map((code: any) => (
                              <option key={code} value={code}>
                                {code}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-md-10">
                          <input
                            type="text"
                            aria-describedby="emailHelp"
                            className="form-control"
                            id="amobileNo"
                            placeholder=""
                            pattern="[0-9]+"
                            value={amobileNo}
                            onChange={amobileNoHandler}
                            maxLength={12}
                            disabled={viewMode}
                            required
                          />
                          <div className="invalid-feedback">
                            Please provide a mobile.
                          </div>
                          {!validaMobileNo && (
                            <div className="invalid-feedback">
                              Invalid mobile no. eg. +6591234567
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    {typeofPermit === "1" && (
                      <div className="mb-2">
                        <label
                          htmlFor="consignmentType"
                          className="form-label mb-2"
                        >
                          Consignment Type <span className="star">*</span>
                        </label>
                        <select
                          className="form-select"
                          aria-label="Default select example"
                          id="consignmentType"
                          value={consignmentType}
                          onChange={consignmentTypeChange}
                          disabled={viewMode || amendMode}
                          required
                        >
                          <option value="" disabled selected hidden>
                            Select Consignment Type
                          </option>
                          {(typeofTransaction === "1" ||
                            typeofTransaction === "4") && (
                            <>
                              <option value="1">Veterinary Biologics</option>
                              <option value="2">Animal Products</option>
                            </>
                          )}
                          <option value="3">Animals</option>
                        </select>
                        <span
                          className="star csp-abs-ml-100-mt--30"
                        >
                          *
                        </span>
                        <div className="invalid-feedback mb-3">
                          Please select Consignment type.
                        </div>
                      </div>
                    )}
                    {typeofPermit === "2" && (
                      <div className="mb-2">
                        <label
                          htmlFor="consignmentType"
                          className="form-label mb-2"
                        >
                          Consignment Type
                        </label>
                        <select
                          className="form-select"
                          aria-label="Default select example"
                          id="consignmentType"
                          value={consignmentType}
                          onChange={consignmentTypeChange}
                          disabled={viewMode || amendMode}
                        >
                          <option value="" disabled selected hidden>
                            Select Consignment Type
                          </option>
                          {(typeofTransaction === "1" ||
                            typeofTransaction === "4") && (
                            <>
                              <option value="1">Veterinary Biologics</option>
                              <option value="2">Animal Products</option>
                            </>
                          )}
                          <option value="3">Animals</option>
                        </select>
                      </div>
                    )}
                    {(typeofTransaction === "1" ||
                      typeofTransaction === "4") && (
                      <div>
                        <div className="mb-3 position-relative">
                          <label
                            htmlFor="exampleFormControlInput1"
                            className="form-label mb-2"
                          >
                            Arrival Method<span className="star">*</span>
                          </label>
                          <select
                            className="form-select"
                            aria-label="Default select example"
                            id="arrivalMethod"
                            value={arrivalMethod}
                            onChange={(e) => setArrivalMethod(e.target.value)}
                            disabled={viewMode}
                            required
                          >
                            <option value="" disabled selected hidden>
                              Select Arrival Method
                            </option>
                            <option value="1">Flight</option>
                            <option value="2">Land</option>
                            <option value="3">Sea</option>
                          </select>
                          <span
                            className="star csp-abs-ml-100-mt--30"
                          >
                            *
                          </span>
                          <div className="invalid-feedback mb-3">
                            Please select Arrival Method.
                          </div>
                        </div>
                        <div className="mb-2">
                          <label
                            htmlFor="countryofOrigin"
                            className="form-label mb-2"
                          >
                            Country of Origin
                          </label>
                          <select
                            className="form-select"
                            aria-label="Default select example"
                            id="countryofOrigin"
                            value={countryOfOrigin}
                            onChange={(e) => setCountryOfOrigin(e.target.value)}
                            disabled={viewMode || amendMode}
                          >
                            <option value="">Select Country of Origin</option>
                            {countries.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    )}
                    {typeofTransaction === "2" && (
                      <div>
                        <div className="mb-3 position-relative">
                          <label
                            htmlFor="exampleFormControlInput1"
                            className="form-label mb-2"
                          >
                            Shipment By<span className="star">*</span>
                          </label>
                          <select
                            className="form-select"
                            aria-label="Default select example"
                            id="shipmentBy"
                            value={shipmentBy}
                            onChange={(e) => setShipmentBy(e.target.value)}
                            disabled={viewMode}
                            required
                          >
                            <option value="" disabled selected hidden>
                              Select Shipment By
                            </option>
                            <option value="1">Flight</option>
                            <option value="2">Land</option>
                            <option value="3">Sea</option>
                          </select>
                          <span
                            className="star csp-abs-ml-100-mt--30"
                          >
                            *
                          </span>
                          <div className="invalid-feedback mb-3">
                            Please select Shipment By.
                          </div>
                        </div>
                        <div className="mb-2">
                          <label
                            htmlFor="shipmentDate"
                            className="form-label mb-2"
                          >
                            Date of Shipment <span className="star">*</span>
                          </label>
                          <DatePicker
                            id="shipmentDate"
                            selected={shipmentDate}
                            onChange={handleShipmentDateChange}
                            className="form-control"
                            wrapperClassName="w-100"
                            minDate={minBookingDate ?? undefined}
                            showIcon
                            placeholderText="dd/mm/yyyy"
                            dateFormat="dd/MM/yyyy"
                            filterDate={(date) =>
                              !(date.getDay() === 0) && !isHoliday(date)
                            }
                            disabled={viewMode}
                            required
                          />
                          {isShipmentDateValid && (
                            <div className="invalid-feedback">
                              Please provide Date of Shipment.
                            </div>
                          )}

                          {!isShipmentDateValid && (
                            <p className="error-message">
                              Date of Shipment to be from Monday to Saturday,
                              excluding public holidays.
                            </p>
                          )}
                        </div>
                        <div className="mb-2 ">
                          <label
                            htmlFor="shipmentTime"
                            className="form-label mb-2"
                          >
                            Time of Shipment <span className="star">*</span>
                          </label>
                          <DatePicker
                            id="shipmentTime"
                            selected={shipmentTime}
                            onChange={handleShipmentTimeChange}
                            className="form-control"
                            wrapperClassName="w-100"
                            showTimeSelect
                            showTimeSelectOnly
                            placeholderText="HH:mm am"
                            dateFormat="hh:mm aa"
                            timeIntervals={30}
                            disabled={viewMode}
                            required
                          />
                          {!isShipmentTimeValid && (
                            <div className="invalid-feedback mb-3">
                              Time of Shipment to be between 00:00 to 23:59.
                            </div>
                          )}
                        </div>
                        <div className="mb-2">
                          <label
                            htmlFor="countryofDestination"
                            className="form-label mb-2"
                          >
                            Country of Destination
                          </label>
                          <select
                            className="form-select"
                            aria-label="Default select example"
                            id="exportCountryofDestination"
                            value={exportCountryofDestination}
                            onChange={handleExportCountryofDestinationChange}
                            disabled={viewMode || amendMode}
                          >
                            <option value="">
                              Select Country of Destination
                            </option>
                            {countries.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    )}
                    <div className="mb-2">
                      <label htmlFor="flightNumber" className="form-label mb-2">
                        Flight Number
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="flightNumber"
                        placeholder="Flight Number"
                        value={flightNumber}
                        maxLength={20}
                        onChange={(event) =>
                          setFlightNumber(event.target.value)
                        }
                        disabled={viewMode}
                      />
                      <div className="invalid-feedback">
                        Please provide a Flight Number .
                      </div>
                    </div>
                    <div className="mb-2">
                      <label
                        htmlFor="vehicleNumber"
                        className="form-label mb-2"
                      >
                        Vehicle Number
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="vehicleNumber"
                        placeholder="Vehicle Number"
                        value={vehicleNumber}
                        maxLength={20}
                        onChange={(event) =>
                          setVehicleNumber(event.target.value)
                        }
                        disabled={viewMode}
                      />
                      <div className="invalid-feedback">
                        Please provide a Vehicle Number .
                      </div>
                    </div>
                    <div className="mb-2">
                      <label htmlFor="vessel" className="form-label mb-2">
                        Vessel
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="vessel"
                        placeholder="Vessel"
                        value={vessel}
                        maxLength={20}
                        onChange={(event) => setVessel(event.target.value)}
                        disabled={viewMode || amendMode}
                      />
                      <div className="invalid-feedback">
                        Please provide a Vessel .
                      </div>
                    </div>
                    <div className="mb-2">
                      <label htmlFor="shipInfo" className="form-label mb-2">
                        Ship Information
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="shipInfo"
                        placeholder="Ship Information"
                        value={shipInfo}
                        maxLength={20}
                        onChange={(event) => setShipInfo(event.target.value)}
                        disabled={viewMode || amendMode}
                      />
                      <div className="invalid-feedback">
                        Please provide Ship Information.
                      </div>
                    </div>
                    {(typeofTransaction === "1" ||
                      typeofTransaction === "4") && (
                      <div>
                        <div className="mb-2">
                          <label
                            htmlFor="arrivalDate"
                            className="form-label mb-2"
                          >
                            Arrival Date <span className="star">*</span>
                          </label>
                          <DatePicker
                            id="arrivalDate"
                            selected={arrivalDate}
                            onChange={handleArrivalDateChange}
                            className="form-control"
                            wrapperClassName="w-100"
                            minDate={minBookingDate ?? undefined}
                            showIcon
                            placeholderText="dd/mm/yyyy"
                            dateFormat="dd/MM/yyyy"
                            filterDate={(date) =>
                              !(date.getDay() === 0) && !isHoliday(date)
                            }
                            disabled={viewMode}
                            required
                          />
                          {isArrivalDateValid && (
                            <div className="invalid-feedback">
                              Please provide Arrival Date.
                            </div>
                          )}
                          {!isArrivalDateValid && (
                            <p className="error-message">
                              Arrival date to be from Monday to Saturday,
                              excluding public holidays.
                            </p>
                          )}
                        </div>
                        <div className="mb-2 ">
                          <label
                            htmlFor="arrivalTime"
                            className="form-label mb-2"
                          >
                            Arrival Time <span className="star">*</span>
                          </label>
                          <DatePicker
                            id="arrivalTime"
                            selected={arrivalTime}
                            onChange={handleArrivalTimeChange}
                            className="form-control"
                            wrapperClassName="w-100"
                            showTimeSelect
                            showTimeSelectOnly
                            placeholderText="HH:mm am"
                            dateFormat="hh:mm aa"
                            timeIntervals={30}
                            disabled={viewMode}
                            required
                          />
                          {!isArrivalTimeValid && (
                            <div className="invalid-feedback mb-3">
                              Arrival time to be between 09:00 to 17:00.
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                    {typeofTransaction === "4" && (
                      <div>
                        <div className="mb-2">
                          <label
                            htmlFor="countryofDestination"
                            className="form-label mb-2"
                          >
                            Country of Destination
                          </label>
                          <select
                            className="form-select"
                            aria-label="Default select example"
                            id="countryofDestination"
                            value={countryofDestination}
                            onChange={handleCountryofDestinationChange}
                            disabled={viewMode || amendMode}
                          >
                            <option value="">
                              Select Country of Destination
                            </option>
                            {countries.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="mb-2">
                          <label
                            htmlFor="departureDate"
                            className="form-label mb-2"
                          >
                            Date of Departure <span className="star">*</span>
                          </label>
                          <DatePicker
                            id="departureDate"
                            selected={departureDate}
                            onChange={handleDepartureDateChange}
                            className="form-control"
                            wrapperClassName="w-100"
                            minDate={arrivalDate ?? undefined}
                            maxDate={maxDepartureDate ?? undefined}
                            showIcon
                            placeholderText="dd/mm/yyyy"
                            dateFormat="dd/MM/yyyy"
                            filterDate={(date) =>
                              !(date.getDay() === 0) && !isHoliday(date)
                            }
                            disabled={!arrivalDate || amendMode || viewMode}
                            required
                          />
                          {isArrivalDateValid && (
                            <div className="invalid-feedback">
                              Please provide Departure Date.
                            </div>
                          )}

                          {!isArrivalDateValid && (
                            <p className="error-message">
                              Arrival date to be from Monday to Friday,
                              excluding public holidays.
                            </p>
                          )}
                        </div>
                        <div className="mb-2 ">
                          <label
                            htmlFor="departureTime"
                            className="form-label mb-2"
                          >
                            Departure Time <span className="star">*</span>
                          </label>
                          <DatePicker
                            id="departureTime"
                            selected={departureTime}
                            onChange={handleDepartureTimeChange}
                            className="form-control"
                            wrapperClassName="w-100"
                            showTimeSelect
                            showTimeSelectOnly
                            minTime={minDepartureTime}
                            maxTime={maxDepartureTime}
                            placeholderText="HH:mm am"
                            dateFormat="hh:mm aa"
                            timeIntervals={30}
                            disabled={!arrivalTime || amendMode || viewMode}
                            required
                          />
                          {!isArrivalTimeValid && (
                            <div className="invalid-feedback mb-3">
                              Departure time to be between 09:00 to 17:00.
                            </div>
                          )}
                        </div>
                        <div className="mb-2 ">
                          <label
                            htmlFor="exampleFormControlInput1"
                            className="form-label mb-2"
                          >
                            Flight Details
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="flightDetails"
                            placeholder=""
                            maxLength={500}
                            value={flightDetails}
                            onChange={(event) =>
                              setFlightDetails(event.target.value)
                            }
                            disabled={viewMode || amendMode}
                          />
                        </div>
                      </div>
                    )}
                    {(typeofTransaction === "2" ||
                      typeofTransaction === "4") && (
                      <div className="mb-2 ">
                        <label
                          htmlFor="exampleFormControlInput1"
                          className="form-label mb-2"
                        >
                          Port of Exit
                        </label>
                        <select
                          className="form-select"
                          aria-label="Default select example"
                          id="portofExit"
                          value={portofExit}
                          onChange={(e) => setPortofExit(e.target.value)}
                          disabled={viewMode || amendMode}
                        >
                          <option value="">Select Port of Exit</option>
                          {ports.map((option) => (
                            <option key={option.id} value={option.id}>
                              {option.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}
                    <div className="mb-2 ">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-2"
                      >
                        Remarks
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="sRemarks"
                        placeholder=""
                        maxLength={200}
                        value={aRemarks}
                        onChange={(event) => setaRemarks(event.target.value)}
                        disabled={viewMode || amendMode}
                      />
                    </div>
                    {showFields &&
                      (typeofTransaction === "1" ||
                        typeofTransaction === "4") && (
                        <div>
                          <div className="mb-2">
                            <label
                              htmlFor="checkinofAnimal"
                              className="form-label mb-2"
                            >
                              Mode of Conveyance
                            </label>
                            <select
                              className="form-select"
                              aria-label="Default select example"
                              id="checkinofAnimal"
                              value={checkinofAnimal}
                              onChange={(e) =>
                                setCheckinofAnimal(e.target.value)
                              }
                              disabled={viewMode || amendMode}
                            >
                              <option value="-1" disabled selected hidden>
                                Select Mode of Conveyance
                              </option>
                              <option value="3">
                                Manifested Cargo (Cargo Plane)
                              </option>
                              <option value="2">
                                Accompanied Baggage (In cabin)
                              </option>
                              <option value="1">
                                Excess Baggage (Checked-In)
                              </option>
                            </select>
                            <span
                              className="star csp-abs-ml-100-mt--30"
                            >
                              *
                            </span>
                            <div className="invalid-feedback mb-3">
                              Please select Mode of Conveyance.
                            </div>
                          </div>
                          <div className="mb-2">
                            <label
                              htmlFor="stopoverPortCountry"
                              className="form-label mb-2"
                            >
                              Stopover Port Country
                            </label>
                            <select
                              className="form-select"
                              aria-label="Default select example"
                              id="stopoverPortCountry"
                              value={stopoverPortCountry}
                              onChange={ahandleStopoverCountryChange}
                              disabled={viewMode || amendMode}
                            >
                              {countries.map((option) => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="mb-2">
                            <label
                              htmlFor="stopoverPortDuration"
                              className="form-label mb-2"
                            >
                              Stopover Port Duration
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="stopoverPortDuration"
                              placeholder=""
                              maxLength={500}
                              value={stopoverPortDuration}
                              onChange={(event) =>
                                setStopoverPortDuration(event.target.value)
                              }
                              disabled={viewMode || amendMode}
                            />
                          </div>
                          <div className="mb-2">
                            <label
                              htmlFor="seaPortforInspection"
                              className="form-label mb-2"
                            >
                              Sea Port for Inspection
                            </label>
                            <select
                              className="form-select"
                              aria-label="Default select example"
                              id="seaPortforInspection"
                              value={seaPortforInspection}
                              onChange={(event) =>
                                setSeaPortforInspection(event.target.value)
                              }
                              disabled={viewMode || amendMode}
                            >
                              <option value="-1" disabled selected hidden>
                                Select Sea Port for Inspection
                              </option>
                              <option value="1">30 min</option>
                              <option value="2">1 hour</option>
                            </select>
                          </div>
                        </div>
                      )}
                  </div>
                )}
                <div className="mb-3 position-relative">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-2"
                  >
                    Inspection Location<span className="star">*</span>
                  </label>
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    id="inspectionLocation"
                    value={inspectionLocation}
                    onChange={handleInspectionLocationChange}
                    disabled={viewMode}
                    required
                  >
                    <option value="" disabled selected hidden>
                      Select Inspection Location
                    </option>
                    <option value="1">
                      Changi Animal and Plant Quarantine (CAPQ)
                    </option>
                    <option value="2">Tuas Checkpoint</option>
                    <option value="3">Other Appointed Place</option>
                  </select>
                  <span
                    className="star csp-abs-ml-100-mt--30"
                  >
                    *
                  </span>
                  <div className="invalid-feedback mb-3">
                    Please select Inspection Location.
                  </div>
                </div>
                {inspectionLocation === "1" && (
                  <div className="mb-2">
                    <p>Days and Time of Operation:</p>
                    <ul className="csp-list-disc">
                      <li>
                        <label>Changi Animal and Plant Quarantine (CAPQ)</label>
                        <label>
                          Monday and Tuesday from 09:00 AM
                          to 05:00 PM.{" "}
                        </label>
                        <label>Wednesday, Thursday and Friday from 09:00 AM to 08:00 PM. </label>
                        <label>Saturday, Sunday and Public Holidays Closed.</label>
                        <label>Closed for Lunch from 01:00 PM to 02:00 PM.</label>
                      </li>
                    </ul>
                  </div>
                )}
                {inspectionLocation === "2" && (
                  <div className="mb-2">
                    <p>Days and Time of Operation:</p>
                    <ul className="csp-list-disc">
                      <li>
                        <label>Tuas Checkpoint </label>
                        <label>
                          Monday to Saturday From 5:00 AM to 11:00 AM.
                        </label>
                      </li>
                    </ul>
                  </div>
                )}
                {!hideOtherAppointedPlace && (
                  <div className="mb-3 position-relative">
                    <input
                      type="text"
                      className="form-control"
                      id="therAppointedPlace"
                      placeholder="Other Appointed Place"
                      value={otherAppointedPlace}
                      onChange={(e) => setOtherAppointedPlace(e.target.value)}
                      disabled={viewMode || amendMode}
                      required
                    />
                    <span
                      className="star csp-abs-ml-100-mt--30"
                    >
                      *
                    </span>

                    <div className="invalid-feedback mb-3">
                      Please provide Other Appointed Place.
                    </div>
                  </div>
                )}
                <div className="mb-2">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-2"
                  >
                    Date of Inspection{" "}
                    <span className="bracket-text">
                      (Please exclude public holidays and Sundays)
                    </span>{" "}
                    <span className="star">*</span>
                  </label>
                  <DatePicker
                    id="ainspectionDateTime"
                    selected={ainspectionDateTime}
                    onChange={handleInspectionDateChange}
                    className="form-control"
                    wrapperClassName="w-100"
                    minDate={minInspectionDate ?? undefined}
                    maxDate={maxInspectionDate ?? undefined}
                    showIcon
                    placeholderText="dd/mm/yyyy"
                    dateFormat="dd/MM/yyyy"
                    /*filterDate={(date) =>
                      !(date.getDay() === 0) && !isHoliday(date)
                    }*/
                    filterDate={(date) => {
                      if (inspectionLocation === '1') {
                        const cutoffDate = new Date(2026, 3, 1); // 1 April 2026
                        const isSunday = date.getDay() === 0;
                        const isSaturday = date.getDay() === 6;
                        return (
                          !isHoliday(date) &&
                          !isSunday &&
                          !(date >= cutoffDate && isSaturday)
                        );
                      } else {
                        return !isHoliday(date) && date.getDay() !== 0;
                      }
                    }}
                    disabled={disableInspectionDate}
                    required
                  />
                  {isValidDate && (
                    <div className="invalid-feedback">
                      Please provide a Date of Inspection.
                    </div>
                  )}

                  {!isValidDate && (
                    <p className="error-message">
                      Inspection date to be from Monday to Friday, excluding
                      public holidays.
                    </p>
                  )}
                </div>

                <div className="mb-2 ">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-2"
                  >
                    Time of Inspection{" "}
                    <span className="bracket-text">
                      (Please refer to the locations' operating hours)
                    </span>{" "}
                    <span className="star">*</span>
                  </label>
                  <DatePicker
                    id="sInspectionTime"
                    selected={ainspectionTime}
                    onChange={handleInspectionTimeChange}
                    className="form-control"
                    wrapperClassName="w-100"
                    showTimeSelect
                    showTimeSelectOnly
                    minTime={minInspectionTime}
                    maxTime={maxInspectionTime}
                    placeholderText="HH:mm am"
                    dateFormat="hh:mm aa"
                    timeIntervals={30}
                    disabled={disableInspectionDate}
                    required
                  />
                  {!isTimeValid && (
                    <div className="invalid-feedback mb-3">
                      Inspection time to be between 09:00 to 17:00.
                    </div>
                  )}

                  {!isInspectionTimeValid && typeofTransaction === "4" && (
                    <div className="invalid-feedback mb-3">
                      Invalid Inspection time. Select Inspection time between
                      arrival time and departure time.
                    </div>
                  )}

                  {!isInspectionTimeValid && typeofTransaction === "1" && (
                    <div className="invalid-feedback mb-3">
                      Invalid Inspection time. Select Inspection time after
                      arrival time.
                    </div>
                  )}

                  {!isInspectionTimeValid && typeofTransaction === "2" && (
                    <div className="invalid-feedback mb-3">
                      Invalid Inspection time. Select Inspection time before
                      shipment time.
                    </div>
                  )}
                </div>
              </div>

              {!disableInspectionDate && (
                <div className="mb-3">
                  <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey={site_Key}
                    onChange={() => setIsCaptchaValid(true)}
                    onExpired={() => setIsCaptchaValid(false)}
                  />
                  {submitted && !isCaptchaValid && (
                    <div className="error-message">
                      Please complete the reCAPTCHA verification.
                    </div>
                  )}
                </div>
              )}
              <button
                type="submit"
                id="submit"
                className="btn btn-success d-block mt-4"
                disabled={disableSubmit}
              >
                Submit
              </button>
              {isSubmiting && <Loader />}
              {errorMessage && <p className="error-message">{errorMessage}</p>}
            </div>
          )}
        </div>
      </form>
    </>
  );
};

export default VetHealthInspectionApplication;
